<div class="dialog-container state-dialog">
  <div class="dialog-body">
    <div class="rate-title">{{title | translate}}</div>
    <div class="rate-message">
      <span *ngIf="message">{{message | translate}}</span>
      <span *ngIf="messageText">{{messageText}}</span>
    </div>
    <div class="rate-text">{{text | translate}}</div>
    <div class="rate-stars">
      <i class="mdi" *ngFor="let star of stars" (mouseenter)="hoverStar(star)" (mouseleave)="hoverStar(0)"
         [ngClass]="starClass(star)" (click)="selectStar(star)"></i>
    </div>
    <div class="rate-btns">
      <button class="w-btn orange-btn" [disabled]="selectedStar < 1" (click)="submitRating(selectedStar)">
        {{'SUBMIT' | translate}}
      </button>
      <button class="w-link-btn" (click)="laterRate()">{{'RATING.LATER' | translate}}</button>
    </div>
    <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
  </div>
</div>
